import {SelectionEntityModel} from "../../infrastructure/models/selection-entity.model";
import {USER_SELECTIONS_MANAGER_ACTIONS} from "../managers/user-selections.manager";
import {BaseModel} from "../../infrastructure/models/base-model";
import {APP} from "../app/consts";

export class UserSelectionModel extends BaseModel {
  entity: SelectionEntityModel;
  action: USER_SELECTIONS_MANAGER_ACTIONS;
  source: APP.ANALYTICS.SOURCES;

  constructor(entity: Number, action: USER_SELECTIONS_MANAGER_ACTIONS, source: APP.ANALYTICS.SOURCES) {
    super();

    this.entity = entity;
    this.action = action;
    this.source = source;
  }
}


